import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import moment from "moment";
import RowDataTableModal from "../../../Component/Modal/RowDataTableModal";

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "15px",
    fontWeight: "bold",
};

function SentEmailsToStaff() {

    const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");
  const loggedUserID = localStorage.getItem("uid");

    const [allData, setAllData] = useState([]);


    const fetchAllData = async () => {
        try {
            const response = await HomeService.getSentEmailsToStaff();
            console.log("WER21", response.data);

            const formattedData = response?.data
            .sort((a, b) => new Date(b.date) - new Date(a.date))
            .map((item, index) => ({
                ...item,
                sln: index + 1,
            }))

                ;
            // setAllData(formattedData || []);
            if (userCity) {
                setAllData(formattedData.filter((item) => item?.city._id === userCity))
              } else {
                setAllData(formattedData || [])
              }
            
        } catch (error) {
            console.error("Error fetching allData:", error);
            toast.error("Failed to fetch allData.");
        }
    };

    const toggleStatus = async (id, currentStatus) => {
        try {
            const newStatus = currentStatus === true ? false : true;
            await HomeService.updateUserStatus(id, { status: newStatus });
            fetchAllData();

            // toast.success(`Property status updated to ${newStatus}!`);
        } catch (error) {
            toast.error("Failed to update property status.");
            console.error("Error updating status:", error);
        }
    };

    useEffect(() => {
        fetchAllData();
    }, []);

    const [selectedRecipientsList, setSelectedRecipientsList] = useState([])
    const [isRecipientsModalOpen, setIsRecipientsModalOpen] = useState(false)
    const handleRecipientsView = (data) => {
        setSelectedRecipientsList(data);
        setIsRecipientsModalOpen(true);
    }

    // Define columns for the data table
    const columns = [
        { name: "SL#", selector: (row) => row.sln, sortable: true },
        { name: "Date", selector: (row) => moment(row?.date).format("DD-MM-YYYY"), sortable: true },
        { name: "City", selector: (row) => row?.city?.name },
        { name: "Role", selector: (row) => row?.role },
        {
            name: 'Recipients',
            cell: (row) => (
                <>
                    {row?.recipients.length}&nbsp;<i className="fa-solid fa-eye " onClick={() => handleRecipientsView(row?.recipients)}
                        style={{ cursor: "pointer", color: 'darkBlue', fontSize: '12px' }}></i>
                </>
            ),
            wrap: true,
            align: "center",
        },
        { name: "Subject", selector: (row) => row?.title, wrap: true },
        { name: "Content/Message", selector: (row) => row?.description, wrap: true },
        {
            name: 'Attachment',
            cell: (row) => (
                <>
                    {
                        row?.attachment.length > 0 && <a href={row?.attachment[0]} target="_blank">View</a>
                    }

                </>
            ),
            wrap: true,
        },
    ];

    return (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
            <div className="container-fluid" id="edit-section">
                <div className="mt-5">
                    <h2 className="text-center" style={headLineStyle}>Sent Emails To Staff</h2>
                    <hr />
                    <DataTable columns={columns} data={allData} pagination />
                    <RowDataTableModal
                        isOpen={isRecipientsModalOpen}
                        closeModal={() => setIsRecipientsModalOpen(false)}
                        data={selectedRecipientsList}
                        title="Recipients List"
                    />
                </div>
            </div>
        </div>
    );
}

export default SentEmailsToStaff;
